import { useFindMany } from "@gadgetinc/react";
import React, { useContext } from "react";
import { Link, useLocation } from "react-router";
import { api } from "../../api";
import { Conversations } from "../../components";
import { PageHeading } from "../../externalComponents";
import { Subheading } from "../../externalComponents/tailwind/heading";
import { CustomerContext } from "../../providers";

const MyConversationsPage = () => {
  const { user, customer } = useContext(CustomerContext);
  const location = useLocation();
  const pathCategory = location.pathname.split("/").slice(-1)[0];

  const [{ data, fetching }] = useFindMany(api.conversation, {
    first: 250,
    filter: [
      {
        customerId: { equals: customer.id },
      },
      {
        attributedUserId: { equals: user.id },
      },
      {
        lastInboundMessageAt: { isSet: true },
      },
      {
        isArchived: { notEquals: true },
      },
      {
        isOpened: { equals: true },
      },
    ],
    select: {
      id: true,
      attributedUser: {
        id: true,
      },
      contact: {
        id: true,
        userPhoneNumber: true,
        bsuid: true,
        whatsappName: true,
        hasOptIn: true,
        optoutAt: true,
        customProperties: true,
        shopifyCustomer: {
          id: true,
          shopifyCreatedAt: true,
          firstName: true,
          lastName: true,
          amountSpent: true,
          totalSpent: true,
          numberOfOrders: true,
          ordersCount: true,
          shop: {
            myshopifyDomain: true,
          },
          lastOrder: {
            id: true,
            name: true,
            financialStatus: true,
            fulfillmentStatus: true,
            shopifyCreatedAt: true,
            totalPrice: true,
            shippingAddress: true,
          },
        },
      },
      lastMessageAt: true,
      lastMessagePreview: true,
      lastReadAt: true,
      lastInboundMessageAt: true,
      isOpened: true,
      lastUnscriptedMessageAt: true,
    },
    sort: {
      lastInboundMessageAt: "Descending",
    },
    live: true,
  });

  const secondaryNavigation = [
    { name: "Opened", href: "/all" },
    { name: "My conversations", href: "/mine" },
    { name: "Closed", href: "/closed" },
  ];

  return (
    <>
      <PageHeading title="Conversations" />
      <Subheading>
        <ul
          role="list"
          className="flex min-w-full flex-none gap-x-6 px-4 py-4 text-base font-semibold leading-6 text-gray-400 sm:px-6 lg:px-8"
          style={{justifyContent: window.innerWidth < 768 ? "space-around" : "flex-start"}}
        >
          {secondaryNavigation.map((item) => (
            <li key={item.name}>
              <Link
                to={"/conversations" + item.href}
                className={item.href === "/" + pathCategory ? "text-pink" : ""}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </Subheading>

      {!fetching && data && <Conversations conversations={data} />}
    </>
  );
};
export default MyConversationsPage;
